import type { FC } from 'react'

import CheckboxBlankCircleOutlineIcon from 'mdi-react/CheckboxBlankCircleOutlineIcon'
import CheckboxBlankOutlineIcon from 'mdi-react/CheckboxBlankOutlineIcon'
import CheckboxMarkedCircleOutlineIcon from 'mdi-react/CheckboxMarkedCircleOutlineIcon'
import CheckboxMarkedOutlineIcon from 'mdi-react/CheckboxMarkedOutlineIcon'

const CheckboxIcon: FC<{ isSelected: boolean; isSingleChoiceList?: boolean }> = ({
  isSelected,
  isSingleChoiceList,
}) => {
  if (isSingleChoiceList) {
    return (
      <td className="check-mark">
        {isSelected ? <CheckboxMarkedCircleOutlineIcon /> : <CheckboxBlankCircleOutlineIcon />}
      </td>
    )
  }

  return (
    <td className="check-mark">
      {isSelected ? <CheckboxMarkedOutlineIcon /> : <CheckboxBlankOutlineIcon />}
    </td>
  )
}

export default CheckboxIcon
